/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from "react";
import { useGetOfferCardStyles } from "./index.styles";
import { NEW_OFFER } from "../../constants";
import NikeSVG from "../../icons/nike";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChessQueen, faCrown } from "@fortawesome/free-solid-svg-icons";
import { FavoriteOutlined } from "@mui/icons-material";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import Branding from "./../../assets/images/Branding.jpg";
import RedeemedBg from "./../../assets/images/redeemed-bg.gif";
import Tooltip from "@mui/material/Tooltip";
import DraftsIcon from "@mui/icons-material/Drafts";
import Typography from "@mui/material/Typography";
import RedeemIcon from "@mui/icons-material/Redeem";
import { createPortal } from "react-dom";
import t from "../../theme";

function MyVerticallyCenteredModal({ onHide, CLick }) {
  return createPortal(
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions
    <div
      onClick={(e) => {
        e.stopPropagation();
        onHide();
      }}
      onKeyDown={(e) => {
        if (e.key === "Escape") onHide();
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "rgba(0, 0, 0, 0.52)",
        backdropFilter: t.blur.minimal,
        WebkitBackdropFilter: t.blur.minimal,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "min(420px, 100%)",
          borderRadius: t.radius.lg,
          background: t.brand.white,
          boxShadow: t.shadow.lg,
          fontFamily: t.font.family,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "16px 18px",
            borderBottom: t.border.light,
          }}
        >
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: t.radius.circle,
              background: "rgba(220, 53, 69, 0.1)",
              border: "1px solid rgba(220, 53, 69, 0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <UnsubscribeOutlinedIcon
              sx={{ fontSize: "1.1rem", color: t.brand.red }}
            />
          </div>
          <h3
            style={{
              margin: 0,
              flex: 1,
              fontSize: "1rem",
              fontWeight: 700,
              color: t.text.primary,
            }}
          >
            Unsubscribe Mail
          </h3>
          <button
            type="button"
            aria-label="Close"
            onClick={onHide}
            style={{
              border: "none",
              background: "rgba(0, 0, 0, 0.06)",
              cursor: "pointer",
              borderRadius: t.radius.circle,
              width: 30,
              height: 30,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              transition: t.transition.fast,
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(0, 0, 0, 0.12)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "rgba(0, 0, 0, 0.06)")
            }
          >
            <CloseIcon sx={{ fontSize: "0.95rem", color: t.text.muted }} />
          </button>
        </div>

        <div
          style={{
            padding: "16px 18px",
            color: t.text.secondary,
            fontSize: "0.85rem",
            lineHeight: 1.55,
          }}
        >
          <p
            style={{
              margin: "0 0 8px",
              fontSize: "0.95rem",
              fontWeight: 700,
              color: t.text.primary,
            }}
          >
            Are you sure you want to unsubscribe?
          </p>
          <p style={{ margin: 0 }}>
            Once you unsubscribe, you will no longer receive this email, and
            it will not be available again.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            padding: "14px 18px",
            borderTop: t.border.light,
            background: "rgba(248, 250, 248, 0.6)",
          }}
        >
          <button
            type="button"
            onClick={onHide}
            style={{
              borderRadius: t.radius.pill,
              padding: "8px 18px",
              border: t.border.medium,
              background: "transparent",
              color: t.text.secondary,
              fontFamily: t.font.family,
              fontWeight: 700,
              fontSize: "0.82rem",
              cursor: "pointer",
              transition: t.transition.fast,
            }}
          >
            Close
          </button>
          <button
            type="button"
            onClick={CLick}
            style={{
              borderRadius: t.radius.pill,
              padding: "8px 18px",
              border: "none",
              background: t.red.gradient,
              color: t.brand.white,
              fontFamily: t.font.family,
              fontWeight: 700,
              fontSize: "0.82rem",
              cursor: "pointer",
              boxShadow: `0 2px 8px ${t.red.glow}`,
              transition: t.transition.fast,
            }}
          >
            Unsubscribe
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

const OfferCard = ({
  onClick,
  UnsubscribeMailClick,
  setShow,
  show,
  showUnSuscribe,
  size,
  maxSize,
  height,
  maxHeight,
  mobile,
  containerStyles,
  isRedeemed,
  isLocation,
  item,
  message = "",
  isFavourite = false,
  onFavouriteMailToggle,
  onRedeemClick,
  status = NEW_OFFER,
  offerDetails = {},
} = {}) => {
  const classes = useGetOfferCardStyles({
    size,
    maxSize,
    containerStyles,
    height,
    maxHeight,
    mobile,
    isRedeemed,
    isSeen: item?.is_seen === "true",
    itemType: item?.type,
    validTo: item?.valid_to,
  });
  const [isFav, setIsFav] = useState(isFavourite);
  const [isRedeemHovered, setIsRedeemHovered] = useState(false);
  const flat = item?.subject?.split(" ");

  // Calculate days remaining
  const getDaysRemaining = () => {
    if (!item?.valid_to) return null;
    const now = new Date();
    const expiryDate = new Date(item.valid_to);
    return Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
  };

  const daysRemaining = getDaysRemaining();

  const onFavClick = (e) => {
    e.stopPropagation();
    const nextFav = !isFav;
    setIsFav(nextFav);
    // Fire the toggle request in the background; roll back the UI if it fails.
    Promise.resolve(onFavouriteMailToggle(e, nextFav)).catch(() => {
      setIsFav(!nextFav);
    });
  };
  const onRedeem = (e) => {
    e.stopPropagation();
    if (typeof onRedeemClick === "function") {
      onRedeemClick(e);
    } else if (typeof onClick === "function") {
      onClick(e);
    }
  };

  return (
    <div css={classes.mailWrapper}>
      <div
        css={[
          classes.container,
          item?.type === "paid"
            ? classes.containerKing
            : classes.containerQueen,
          containerStyles,
        ]}
        onClick={onClick}
      >
        <div css={classes.wrapper}>
          <div css={classes.mailImage}>
            {/* {item?.mime_type === "image/png" ||
            item?.mime_type === "image/jpeg" ? (
              <img
                key="1"
                alt={item?.brand[0]?.logo_url || Branding}
                src={item?.brand[0]?.logo_url || Branding}
              />
            ) : item?.mime_type === "application/pdf" ? (
              <img
                key="2"
                alt={item?.brand[0]?.logo_url || Branding}
                src={item?.brand[0]?.logo_url || Branding}
              />
            ) : item?.mime_type === "application/icon" ? (
              <NikeSVG width="70%" height="70%" />
            ) : (
              <img
                key="3"
                alt={item?.brand[0]?.logo_url || Branding}
                src={item?.brand[0]?.logo_url || Branding}
              />
            )} */}
            <img
                key="1"
                alt={item?.thumbnail_url || Branding}
                src={item?.thumbnail_url || Branding}
              />
          </div>
          <div css={classes.cardHeaderWrapper}>
            {item?.type === "paid" ? (
              <FontAwesomeIcon
                icon={faCrown}
                className={`fa fa-regular`}
                color="#eda213"
              />
            ) : (
              <FontAwesomeIcon
                icon={faChessQueen}
                className={`fa fa-regular`}
                color="green"
              />
            )}
            {/* {!isRedeemed && ( */}
            <span css={classes.cardFooterText}></span>
            {/* )} */}
          </div>
          <div css={classes.offerTitleWrapper}>
            {/* <span css={classes.offerTitle}>{flat?.[0]} {flat?.[1]}</span>
            <span css={classes.offerSubText}>{flat?.[2]} {flat?.[3]}</span> */}
            <h6 css={classes.offerTitle}>{item?.subject}</h6>

            {item.message && (
              <div
                css={classes.mailMessage}
                dangerouslySetInnerHTML={{ __html: item.message }}
              />
            )}
            <div css={classes.offerLike}>
              <div css={classes.iconsWrapper}>
                {show && (
                  <MyVerticallyCenteredModal
                    show={show}
                    onHide={() => setShow(false)}
                    CLick={() => UnsubscribeMailClick()}
                  />
                )}
                <IconButton
                  css={[
                    classes.favIcon,
                    { overflow: "hidden", zIndex: "1000" },
                  ]}
                  onClick={onFavClick}
                >
                  {isFav ? (
                    <FavoriteOutlined sx={{ color: "red" }} />
                  ) : (
                    <FavoriteBorderOutlinedIcon sx={{ color: "red" }} />
                  )}
                </IconButton>

                {showUnSuscribe && (
                  <IconButton
                    css={[
                      classes.favIcon,
                      { overflow: "hidden", zIndex: "1000" },
                    ]}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShow(true);
                    }}
                  >
                    <Tooltip
                      title="Unsubscribe Mail"
                      placement="top-start"
                      arrow
                    >
                      <UnsubscribeOutlinedIcon sx={{ color: "#777" }} />
                    </Tooltip>
                  </IconButton>
                )}
              </div>

              {item?.type === "paid" && !isRedeemed ? (
                <span
                  css={classes.offerSubText}
                  onMouseEnter={() => setIsRedeemHovered(true)}
                  onMouseLeave={() => setIsRedeemHovered(false)}
                  onClick={onRedeem}
                >
                  <RedeemIcon color="error" />
                  <span className="redeem-text">Redeem</span>
                  <span className="amount">{item?.amount}</span>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            css={classes.mailActions}
            className={item?.is_seen === "true" ? "seen" : "unseen"}
          >
            {item?.type === "paid" && isRedeemed ? (
              <div css={[classes.mailTag, classes.redeemTag]}>
                {item?.amount} Redeemed
              </div>
            ) : (
              ""
            )}
            {item?.type === "paid" && item?.is_seen === "false" && (
              <div>
                {/* <MailIcon color="action" sx={{color:"white", fontSize: '1.2rem', marginRight: '5px'}} /> New */}
              </div>
            )}
            {item?.type === "regular" && item.is_seen === "true" ? (
              <div css={[classes.mailTag, classes.seenTag]}>
                <DraftsIcon
                  sx={{
                    fontSize: "1.2rem",
                    marginRight: "5px",
                    color: "#ffffff",
                  }}
                />
                {/* <FontAwesomeIcon icon={faEye} className={`fa-1x fa-regular`} color="#54ac34" width={30} /> */}
                Seen
              </div>
            ) : (
              ""
            )}
            {item?.type === "regular" && item.is_seen === "false" ? null : ""}
          </div>
        </div>
        {item?.valid_to && item.is_seen === "false" && (
          <div
            css={classes.cardFooter}
            className="cardFooter-validity"
            style={{ opacity: isRedeemHovered ? 0 : 1 }}
          >
            {daysRemaining !== null && daysRemaining <= 3 ? (
              <>
                {daysRemaining === 1
                  ? "Expiring today"
                  : daysRemaining === 2
                    ? "Expiring tomorrow"
                    : `Expiring in ${daysRemaining} days`}
              </>
            ) : (
              <>
                {daysRemaining !== null
                  ? `${daysRemaining} days remaining`
                  : "Valid Till"}{" "}
                {daysRemaining === null || daysRemaining > 3 ? (
                  <Typography>
                    {new Date(item?.valid_to).toLocaleString("en-GB", {
                      timeZone: "UTC",
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                    })}
                  </Typography>
                ) : null}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OfferCard;
